document.addEventListener('DOMContentLoaded', function() {
  let carouselCount = 0; // Counter to ensure unique IDs

  function replaceProductShortcodes() {
    const blogContent = document.querySelectorAll('.rte');
    blogContent.forEach((content) => {
      const regex = /\[product handle="([\w-,]+)"\]/g; // Regex to match product handles
      let matches;
      while ((matches = regex.exec(content.innerHTML)) !== null) {
        const productHandles = matches[1].split(',').map(handle => handle.trim()); // Split handles and trim spaces
        
        console.log('Extracted product handles:', productHandles); 

        if (productHandles.length === 0 || productHandles[0] === '') {
          console.error('No valid product handles found in the shortcode.');
          continue; // Skip to the next match
        }

        // Increment carousel count to ensure unique ID
        const carouselID = `owl-carousel-${carouselCount++}`;

        // Fetch the product data and pass the carousel ID
        fetchProductsData(productHandles, content, carouselID);
      }
    });
  }

  function fetchProductsData(productHandles, content, carouselID) {
    const productPromises = productHandles.map(handle => {
      if (!handle) {
        console.error(`Empty product handle provided.`);
        return Promise.reject(new Error('Empty handle'));
      }
      return fetch(`/products/${handle}.js`).then(response => {
        if (!response.ok) {
          console.error(`Product not found for handle: ${handle}`); // Log which handle fails
          throw new Error('Product not found');
        }
        return response.json();
      });
    });

    Promise.all(productPromises)
      .then(products => {
        // Build carousel HTML
        const carouselHTML = products.map(product => `
          <div class="article" style="text-align: center;margin-left:10px;">
            <div class="figure">
              <a id="product-shortcode-carousel" href="${product.url}"><img src="${product.images[0]}" alt="${product.title}"></a>
            </div>
            <div class="aside">
              <h6 class="shortcode"><a id="product-shortcode-carousel" class="shortcode" href="${product.url}">${product.title.length > 55 ? product.title.substring(0, 55) + '...' : product.title}
</a></h6>
              <p class="price">$${(product.price / 100).toFixed(2)}</p>
              <button id="product-shortcode-carousel" class="add-to-cart read-more-shortcode" data-id="${product.variants[0].id}">Add to Cart</button>
            </div>
          </div>
        `).join('');

        // Wrap the carousel HTML with a unique ID
        const carouselWrapper = `
          <div id="${carouselID}" class="owl-carousel product-slider2 product-slider-blog">
            ${carouselHTML}
          </div>
        `;

        // Replace the shortcode with the carousel
        content.innerHTML = content.innerHTML.replace(`[product handle="${productHandles.join(',')}"]`, carouselWrapper);

        // Initialize Owl Carousel after adding HTML for this specific carousel
        initializeOwlCarousel(`#${carouselID}`);
      })
      .catch(error => {
        console.error("Error fetching product data:", error);
      });
  }

  // Initialize Owl Carousel for a specific carousel
  function initializeOwlCarousel(carouselSelector) {
    // Wait for a short period to ensure the carousel is rendered in the DOM
    setTimeout(() => {
      $('.owl-carousel').on('initialized.owl.carousel changed.owl.carousel', function(event) {
        $('.owl-prev').removeClass('disabled'); // Remove the disabled class
        $('.owl-next').removeClass('disabled'); // Remove the disabled class
    })
	$(carouselSelector).owlCarousel({
        loop: false,
        margin: 16,
        nav: false,
        onTranslated: function(event) {
            // Re-enable the navigation buttons
            $(".owl-next, .owl-prev").removeClass("disabled");
        },
        dots: true,
        autoplay: false,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
		responsive:{
			0:{
				autoWidth: true,
			},			

			768:{
				items: 3,
				margin: 24,
				nav: true, 
				dots: false,		 
			},	
			
			992:{
				items: 3,
				margin: 24,
				nav: true, 
				dots: false,		 
			},	

			1200:{
				items: 4,
				margin: 15,
				nav: true, 
				dots: false, 
			}
		}
      });
    }, 500); // Add a slight delay to make sure the carousel HTML is rendered before initialization
  }

  // Event listener using event delegation to handle dynamic buttons
  document.body.addEventListener('click', function(event) {
    if (event.target.classList.contains('add-to-cart')) {
      const variantId = event.target.getAttribute('data-id');
      if (variantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Add to Cart response:', data);
        })
        .catch(error => {
          alert('Failed to add product to cart.');
          console.error('Error adding product to cart:', error);
        });
      }
    }
  });

  replaceProductShortcodes();
});




